module.exports = __webpack_public_path__ + "helveticaneueltstd-lt-webfont.2fbb334a95103932765e.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/helveticaneueltstd-lt-webfont.ttf
// module id = ../../../../../src/assets/fonts/helveticaneueltstd-lt-webfont.ttf
// module chunks = styles